import { RoundButton } from '@/components';
import { CloseLineIcon } from '@components/icons/react/close-line';
import { MenuLineIcon } from '@components/icons/react/menu-line';

import styles from './MobileHeader.module.scss';

interface MenuToggleButtonProps {
  controlsId: string;
  isOpen: boolean;
  onToggle: () => void;
}

export function MenuToggleButton({ controlsId, isOpen, onToggle }: MenuToggleButtonProps) {
  const Icon = isOpen ? CloseLineIcon : MenuLineIcon;

  const toggleLabel = isOpen ? 'Close primary navigation' : 'Open primary navigation';

  return (
    <RoundButton
      variant="subtle"
      size="medium"
      id={`${controlsId}-toggle`}
      aria-expanded={isOpen}
      aria-controls={controlsId}
      aria-label={toggleLabel}
      aria-haspopup="dialog"
      onClick={onToggle}
      type="button"
    >
      <Icon
        aria-hidden="true"
        color="var(--color-icon-brand-primary)"
        className={styles.menuToggle}
        focusable="false"
      />
    </RoundButton>
  );
}
